import { createRootRoute, redirect } from '@tanstack/react-router';

import { isAuthenticated } from '@/api/useAuth';
import App from '@/App';
import { ROUTE_CONSTANTS } from '@/routes';

export const Route = createRootRoute({
  component: Root,
  beforeLoad: ({ location }) => {
    if (location.pathname === ROUTE_CONSTANTS.LOGIN_PATH) {
      return;
    }
    if (!isAuthenticated()) {
      localStorage.setItem('redirectUrl', location.pathname);
      throw redirect({
        to: ROUTE_CONSTANTS.LOGIN_PATH,
      });
    }
  },
});

export function Root() {
  return <App />;
}
